import React, { useState, useCallback, useEffect } from "react";

import { Helmet } from 'react-helmet-async';

import {
    Box,
    Paper,
    Divider,
    TextField,
    Grid,
    Typography,
    Switch,
    FormControlLabel,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    FormHelperText,
    ListSubheader,
    List,
    ListItem,
    IconButton,
    ListItemButton,
    styled,
    Card,
    Button,
    Tooltip,
    Checkbox,
    Chip,
    ListItemText,
    OutlinedInput,
} from '@mui/material';

import { grey, red } from "@mui/material/colors";

import { useNavigate, useParams } from "react-router-dom";
import { useFormik } from 'formik';

import CommonBreadcumbs from '../../../../../components/common/CommonBreadcumbs'
import CommonSectionHeader from "../../../../../components/common/CommonSectionHeader";
// import CommonRestricted from '../../../../../components/common/CommonRestricted';
import { CommonIcons, icons } from '../../../../../components/common/CommonIcons';

import { mergeSchema } from "../../../../../utils/dataSchema"

import { useSystemPrompt } from "../../../../../hooks/useSystemPrompt";
import { useAppContextFeatures } from '../../../../../context/AppContext';

import {
    useCustomer,
    initialValues,
    initialRowValues,
    initialPasswordValues,
    validationSchema,
    validationPasswordSchema,
    customerInjectionProps
} from "../../../hooks/model/useCustomer";

import {
    useMarking,
    markingInjectionProps,
    branchTypes
} from "../../../hooks/model/useMarking"

import { useSystemRoutes, routeTypes } from '../../../../../hooks/useSystemRoutes'
import { useSystemHead, headTitles } from '../../../../../hooks/useSystemHead';
import { usePermissions, scopeIds, scopeTypes, functionTypes } from '../../../../../hooks/usePermissions';
import { useTranslations } from "../../../../../hooks/useTranslations";

// import NewBranch from "../../@user_branches/customers/NewBranch"
import UpdateBranch from "../../@user_branches/customers/UpdateBranch"
// import NewBranchUser from "../../../../../components/@branch_users/customers/NewBranchUser";
import UpdateBranchUser from "../../../../../components/@branch_users/customers/UpdateBranchUser";

// import { useStateCustomFields } from "../../../../../hooks/state/useStateCustomFields";

import { getInjectionDataType } from "../../../utils/injectionSelection";

const StyledCard = styled(Card)(({ theme }) => ({
    padding: theme.spacing(2)
}));

const StyledCard2 = styled(Card)(({ theme }) => ({
    padding: theme.spacing(0)
}));

const StyledListHeader = styled(ListSubheader)(({ theme }) => ({
    backgroundColor: grey[100],
    textTransform: 'capitalize',
}));

export default function UpdateCustomer({
    routeType
}) {

    const { t } = useTranslations({ ns: ["common", "@user", "_prompt", "_common"] })

    const { id } = useParams();

    const { promptMessage } = useSystemPrompt();

    const {
        listMarkings,
        filterOperatorTypes
    } = useMarking({ routeType })

    const {
        listCustomers,
        getCustomer,
        updateCustomer
    } = useCustomer({ routeType })

    const { isPermissionAllow } = usePermissions(
        routeType,
        scopeIds.user.id,
        scopeTypes[scopeIds.user.id].customer.id
    )

    const { setSystemLoading, openCustomDrawer, closeCustomDrawer } = useAppContextFeatures()

    const navigate = useNavigate();
    const [savedValues, setSavedValues] = useState()
    const { getRoute } = useSystemRoutes(routeType);
    const [dataBranches, setDataBranches] = useState([])
    const [dataBranchUsers, setDataBranchUsers] = useState([])
    const { getHtmlHead } = useSystemHead(routeType)
    const [customFields, setCustomFields] = useState([])

    const [checked, setChecked] = useState(false);

    // if checkbox is true only merge those validation together
    const getSchema = () => {
        if (checked === true) {
            return mergeSchema(validationSchema, validationPasswordSchema);
        }
        return validationSchema
    }

    // get check box action and save the state for the action clicked
    const handleAllowChangePassword = (event) => {
        setChecked(event.target.checked);
    };

    const loadData = useCallback(async (id) => {

        setSystemLoading(true)

        try {

            const data = await getCustomer({ id, dataTypesArray: [`${getInjectionDataType('customer')}`, "customer_injection_props_array"] })

            const { customer, custom_fields: savedCustomFields = [] } = data;
            const { injection_props: injectionProps } = customer

            const cf = []

            let items = [];

            injectionProps.forEach(m => {

                if (m?.type.toLowerCase() === customerInjectionProps.marking.submitKey.toLowerCase()) {

                    items.push(
                        {
                            marking: m.value
                        }
                    )

                }

            })

            if (items.length <= 0) {
                items.push(initialRowValues)
            }

            let _injectionProps = {
                [customerInjectionProps.marking.retrieveKey]: customer[customerInjectionProps.marking.retrieveKey],
                [customerInjectionProps.sourceClientRemId.retrieveKey]: customer[customerInjectionProps.sourceClientRemId.retrieveKey],
                [customerInjectionProps.sourceAgentRemId.retrieveKey]: customer[customerInjectionProps.sourceAgentRemId.retrieveKey],
                [customerInjectionProps.sourceProfileType.retrieveKey]: customer[customerInjectionProps.sourceProfileType.retrieveKey],
            }

            setSavedValues({
                userId: customer?.id,
                username: customer.username ? customer.username : "",
                firstname: customer.firstname ? customer.firstname : '',
                lastname: customer.lastname ? customer.lastname : '',
                contactno: customer.contact ? customer.contact : '',
                address: customer.address ? customer.address : '',
                email: customer.email ? customer.email : '',
                status: customer?.status === '1',
                companyname: customer.company_name ? customer.company_name : '',
                regno: customer.reg_no ? customer.reg_no : '',
                code: customer.code ? customer.code : '',
                accountcode: customer.account_code ? customer.account_code : '',
                remark: customer.remark ? customer.remark : "",
                ...initialPasswordValues,
                rows: items,
                injectionProps: _injectionProps

            })

            // console.log(_injectionProps)

        } catch (error) {
            promptMessage(false, `${error?.message}`)
        }

        setSystemLoading(false)

    }, [id])

    // const validateInputMarkings = async (props) => {

    //     const {
    //         markings
    //     } = props

    //     // console.log('markings', markings)

    //     let allResponses = await Promise.all(markings.map(async (marking) => {
    //         const res = await fetchCustomers({ marking })
    //         return res
    //     }));

    //     // console.log('allResponses', allResponses)

    //     let validateResults = []

    //     // check all markings response
    //     allResponses.forEach((response, index) => {

    //         let isTaken = false
    //         let isTakenBy = ""
    //         let marking = markings[index]

    //         response.forEach(i => {
    //             if (i?.user_id !== id) {
    //                 isTaken = true
    //                 isTakenBy = i?.user_id
    //             }
    //         })

    //         validateResults.push({
    //             marking,
    //             isTaken,
    //             isTakenBy
    //         })

    //     })

    //     // console.log('vali', validateResults)

    //     return validateResults
    // }

    const onSubmit = async (currentValues) => {

        try {

            const { rows } = values;

            let inputMarkings = []

            currentValues.rows.forEach(item => {
                inputMarkings.push(item?.marking)
                // return false;
            })

            let payload = {
                customerUserId: id,
                inputMarkings,
                credential: {
                    firstname: currentValues?.firstname,
                    lastname: currentValues?.lastname,
                    password: currentValues?.password,
                    contact: currentValues?.contactno,
                    email: currentValues?.email,
                    status: currentValues?.status,
                },
                customer: {
                    regNo: currentValues?.regno,
                    companyName: currentValues?.companyname,
                    code: currentValues?.code,
                    accountCode: currentValues?.accountcode,
                    remark: currentValues?.remark,
                },
            }

            let response = await updateCustomer(payload)

            promptMessage(true, `Changes has been saved with markings`)

            navigate(getRoute("users/customers"))

        } catch (error) {
            promptMessage(false, `Action Failed. (${error?.message})`)
        }

        return false
    }

    const fetchCustomers = async ({ marking }) => {

        try {

            const props = {
                limit: 5,
                skip: 0,
                sortInfo: {
                    id: "id",
                    dir: 0,
                },
                filterValue: [
                    {
                        name: customerInjectionProps.marking.retrieveKey,
                        operator: filterOperatorTypes.havingInOr,
                        value: JSON.stringify([marking])
                    }
                ],
            }

            const { data } = await listCustomers({
                props
            })

            return data

        } catch (error) {
            promptMessage(false, `${error?.message}`)
        }

        return true

    }

    const fetchDataBranch = async (id) => {

        try {

            const props = {
                limit: -1,
                skip: 0,
                sortInfo: {
                    id: "id",
                    dir: 0,
                },
                filterValue: [
                    // {
                    //     name: "user_id",
                    //     operator: filterOperatorTypes.eq,
                    //     value: id
                    // }
                ],
            }

            const { data } = await listMarkings({
                props,
                customerUserId: id,
                disableServerClientCancellation: true
            })

            setDataBranches(data)

        } catch (error) {
            promptMessage(false, `${error?.message}`)
        }

    }

    // const fetchDataBranchUser = async (id) => {

    //     try {

    //         const props = {
    //             limit: -1,
    //             skip: 0,
    //             sortInfo: {
    //                 id: "id",
    //                 dir: 0,
    //             },
    //             filterValue: [
    //                 {
    //                     name: "parent_user_id",
    //                     operator: filterBranchUser.eq,
    //                     value: id
    //                 }
    //             ]
    //         }

    //         const { data } = await listBranchUsers(props)

    //         // console.log("data?.branch_users", data?.branch_users)

    //         setDataBranchUsers(data?.branch_users)

    //     } catch (error) {
    //         promptMessage(false, `${error?.message}`)
    //     }

    // }

    useEffect(() => {

        loadData(id);
        // fetchDataBranchUser(id)
        fetchDataBranch(id)

    }, [])

    const formik = useFormik({
        initialValues: savedValues,
        validationSchema: getSchema(),
        enableReinitialize: true,
        onSubmit
    });

    const { values, errors, touched, handleChange, setFieldValue } = formik;

    // const getAddNewComponent = (props) => {

    //     const { branchType, branchUserType } = props

    //     if (branchType === branchTypes.customer) {
    //         return (
    //             <NewBranch
    //                 routeType={routeType}
    //                 parentUserId={id}
    //                 handleOnSuccess={() => {
    //                     closeCustomDrawer()
    //                     fetchDataBranch(id)
    //                 }}
    //             />
    //         )
    //     }

    //     if (branchUserType === branchUserTypes.customer) {
    //         return (
    //             <NewBranchUser
    //                 routeType={routeType}
    //                 handleOnSuccess={() => {
    //                     closeCustomDrawer()
    //                     fetchDataBranchUser(id)
    //                 }}
    //             />
    //         )
    //     }

    //     return false

    // }

    // const handleItemNew = ({ branchType = '', branchUserType = '' }) => {

    //     if (!branchType && !branchUserType) return false

    //     openCustomDrawer({
    //         show: true,
    //         anchor: "right",
    //         title: `${branchType === branchTypes.customer ? t('newBranch') : t('newBranchUser')}`,
    //         PaperProps: {
    //             sx: { width: 2 / 3 }
    //         },
    //         handleOnClose: () => { },
    //         ComponentActions:
    //             <></>,
    //         ComponentBody: getAddNewComponent({ branchType, branchUserType })

    //     })

    //     return true;

    // }

    const handleItemEdit = ({ branchType = '', branchUserType = '', itemId }) => {

        if (!branchType && !branchUserType) return false;

        // console.log('itemId => ', itemId)

        openCustomDrawer({
            show: true,
            anchor: "right",
            title: `${branchType === branchTypes.customer ? t('updateBranch') : t('updateBranchUser')}`,
            PaperProps: {
                sx: { width: 2 / 3 }
            },
            handleOnClose: () => { },
            ComponentActions:
                <></>,
            ComponentBody:

                (branchType === branchTypes.customer) ?
                    <UpdateBranch
                        routeType={routeType}
                        id={itemId}
                        parentUserId={id}
                        handleOnSuccess={() => {
                            closeCustomDrawer()
                            fetchDataBranch(id)
                        }}
                    />
                    :
                    <UpdateBranchUser
                        routeType={routeType}
                        id={itemId}
                        handleOnSuccess={() => {
                            closeCustomDrawer()
                            // fetchDataBranchUser(id)
                        }}
                    />
        })

        return true;

    }

    // const handleItemDelete = async ({ branchType = '', branchUserType = '', itemId }) => {

    //     setSystemLoading(true)

    //     try {

    //         if (branchType === branchTypes.customer) {
    //             let result = await removeBranch({ ids: [itemId] })
    //             promptMessage(true, result?.message)
    //             fetchDataBranch(id)
    //         }

    //         if (branchUserType === branchUserTypes.customer) {
    //             let result = await removeBranchUser({ ids: [itemId] })
    //             promptMessage(true, result?.message)
    //             fetchDataBranchUser(id)
    //         }

    //     } catch (error) {
    //         promptMessage(false, `Action Failed (${error?.message})`)
    //     }

    //     setSystemLoading(false)

    // }

    const handleMarkingAddItem = ({ rows, setFieldValue }) => {

        rows.push(initialRowValues);
        setFieldValue('rows', rows)

    }

    const handleMarkingRemoveItem = ({ rows, index, setFieldValue }) => {

        const currentLine = rows ? rows.length : 0;

        if (currentLine <= 1) {
            promptMessage(false, t('itemsAtLeastHave1Row'))
            return false;
        }

        const newRows = rows.filter((i, ind) => ind !== index)

        // rows.remove(index);
        setFieldValue('rows', newRows)

        return true;

    }

    const RenderMarkingRow = () => {

        const rows = values?.rows;

        return (
            <Box>
                <Box>
                    {
                        rows && rows.length > 0
                        && rows.map((item, index) => {

                            const itemValues = item;
                            let itemTouched = touched?.rows
                            let itemErrors = errors?.rows
                            // const itemTouched = touched?.rows

                            if (itemTouched) {
                                itemTouched = (itemTouched[index] !== undefined) ? itemTouched[index] : {};
                            }

                            if (itemErrors) {
                                itemErrors = (itemErrors[index] !== undefined) ? itemErrors[index] : {};
                            }

                            return (
                                <Grid key={index} item xs={12} sm={12} md={12}>

                                    <Grid container spacing={1} >

                                        <Grid item xs={12} sm={12} md={0.5} alignContent={"center"}>
                                            <IconButton
                                                sx={{
                                                    mt: 1,
                                                    // mr: 2
                                                }}
                                                aria-label="delete"
                                                onClick={() => handleMarkingRemoveItem({ rows: values.rows, index, setFieldValue })}
                                            >
                                                <CommonIcons name={icons.remove} />
                                            </IconButton>
                                        </Grid>

                                        <Grid item xs={12} sm={12} md={6}>
                                            <TextField
                                                margin="dense"
                                                size="small"
                                                fullWidth
                                                name={`rows.${index}.marking`}
                                                label={t('marking')}
                                                type="text"
                                                variant="outlined"
                                                value={itemValues?.marking ? itemValues.marking : ""}
                                                onChange={handleChange}
                                                error={Boolean(itemErrors?.marking)}
                                                helperText={itemErrors?.marking}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            )
                        })
                    }
                </Box>

            </Box>
        )
    }

    const RenderMarkingItemInfo = () => {
        return (
            <>
                <Grid item xs={12} sm={12} md={3} textAlign={"left"}>
                    <CommonSectionHeader
                        title={t('markingInfo')}
                        subTitle={t('detailsOfMarkingInformation')}
                    />
                </Grid>

                <Grid item xs={12} sm={12} md={8.5}>
                    {
                        RenderMarkingRow()
                    }
                </Grid>

                <Grid item xs={12} sm={12} md={3}>
                    <></>
                </Grid>

                <Grid item xs={12} sm={12} md={4.5} textAlign={"right"}>
                    <Button
                        variant="outlined"
                        sx={{ mt: 2 }}
                        fullWidth
                        startIcon={<CommonIcons name={icons.add} />}
                        onClick={() => handleMarkingAddItem({ rows: values.rows, setFieldValue })}
                    >
                        {t('addMarking')}
                    </Button>
                </Grid>

            </>
        )
    }

    const RenderEmpty = ({ branchType = '' }) => {

        if (!branchType) return <></>

        return (
            <StyledCard2>
                <Box
                    sx={{
                        width: '100%',
                        position: 'relative',
                        overflow: 'auto',
                        minHeight: 300,
                    }}
                    display={"flex"}
                    flexDirection={"column"}
                    justifyContent={"center"}
                    alignItems={"center"}
                >
                    <Box>
                        {t('youHaveNotCreatedAnyItemYet')}
                    </Box>
                    {/* <Button
                        variant="outlined"
                        sx={{
                            mt: 1
                        }}
                        onClick={() => handleItemNew({ branchType })}
                    >
                        {t('createNew')}
                    </Button> */}
                </Box>
            </StyledCard2>
        )
    }

    const RenderBranchUserEmpty = ({ branchUserType = '' }) => {

        if (!branchUserType) return <></>

        return (
            <StyledCard2>
                <Box
                    sx={{
                        width: '100%',
                        position: 'relative',
                        overflow: 'auto',
                        minHeight: 300,
                    }}
                    display={"flex"}
                    flexDirection={"column"}
                    justifyContent={"center"}
                    alignItems={"center"}
                >
                    <Box>
                        {t('youHaveNotCreatedAnyItemYet')}
                    </Box>
                    {/* <Button
                        variant="outlined"
                        sx={{
                            mt: 1
                        }}
                        onClick={() => handleItemNew({ branchUserType })}
                    >
                        {t('createNew')}
                    </Button> */}
                </Box>
            </StyledCard2>
        )
    }

    const RenderChangePassword = () => {

        if (checked === false) return <></>

        return (
            <>
                <Grid item xs={12} sm={12} md={6} textAlign={"left"}>
                    <TextField
                        margin="dense"
                        size="small"
                        fullWidth
                        name={"password"}
                        label={t('password')}
                        type="password"
                        variant="outlined"
                        value={values.password}
                        onChange={handleChange}
                        error={touched.password && Boolean(errors.password)}
                        helperText={touched.password && errors.password}
                    />
                </Grid>

                <Grid item xs={12} sm={12} md={6} textAlign={"left"}>
                    <TextField
                        margin="dense"
                        size="small"
                        fullWidth
                        name={"passwordconfirm"}
                        label={t('confirmPassword')}
                        type="password"
                        variant="outlined"
                        value={values.passwordconfirm}
                        onChange={handleChange}
                        error={touched.passwordconfirm && Boolean(errors.passwordconfirm)}
                        helperText={touched.passwordconfirm && errors.passwordconfirm}
                    />
                </Grid>
            </>
        )

    }

    // const RenderCustomFieldSelection = () => {

    //     if (!values?.rows) return <></>

    //     const rows = values.rows

    //     return (
    //         <>
    //             <Grid item xs={12}>
    //                 <Divider sx={{ mt: 2, mb: 1 }} />
    //             </Grid>

    //             <Grid item xs={12} sm={12} md={3} textAlign={"left"}>
    //                 <CommonSectionHeader
    //                     title='Custom Properties'
    //                     subTitle={"Provide custom item information"}
    //                 />
    //             </Grid>
    //             <Grid item xs={12} sm={12} md={9}>
    //                 <List>
    //                     {
    //                         values.rows.map((item, index) => {

    //                             const { rows } = values

    //                             let itemValues = rows.length ? rows[index] : {}

    //                             let {
    //                                 fieldType,
    //                                 fieldLabel,
    //                                 fieldKey
    //                             } = item

    //                             return (
    //                                 <ListItem
    //                                     key={index}
    //                                     divider
    //                                     disablePadding
    //                                     sx={{
    //                                         py: 1
    //                                     }}
    //                                 >
    //                                     <Grid container spacing={1}>
    //                                         <Grid item md={3} xs={12} sm={12} display={"flex"} flexDirection={"column"} justifyContent={"center"} alignItems={"center"} >
    //                                             <Chip
    //                                                 label={fieldLabel}
    //                                                 color='primary'
    //                                                 variant='outlined'
    //                                                 size='large'
    //                                                 sx={{
    //                                                     width: '100%',
    //                                                     // textAlign: 'left',
    //                                                     fontSize: 16,
    //                                                     fontWeight: 800
    //                                                 }}
    //                                             />
    //                                         </Grid>
    //                                         <Grid item md={9} xs={12} sm={12}>

    //                                             {
    //                                                 fieldType === inputTypesDef.textbox &&

    //                                                 RenderCustomFieldSelectionTextbox({
    //                                                     index,
    //                                                     item,
    //                                                     itemValues,
    //                                                     inputProps: {
    //                                                         fullWidth: true,
    //                                                         name: `rows.${index}.customValue`,
    //                                                         label: itemValues?.fieldLabel,
    //                                                         type: "text",
    //                                                         variant: "outlined",
    //                                                         value: itemValues?.customValue,
    //                                                         onChange: (event) => setFieldValue(`rows.${index}.customValue`, event.target.value),
    //                                                         // error: Boolean(itemErrors?.customValue),
    //                                                         // helperText: itemErrors?.customValue
    //                                                     }
    //                                                 })
    //                                             }

    //                                             {
    //                                                 fieldType === inputTypesDef.dropdown &&

    //                                                 RenderCustomFieldSelectionDropdown({
    //                                                     index,
    //                                                     item,
    //                                                     itemValues,
    //                                                     selectProps: {
    //                                                         labelId: "customValue",
    //                                                         label: itemValues?.fieldLabel,
    //                                                         name: `rows.${index}.customArray`,
    //                                                         onChange: (event) => {
    //                                                             setFieldValue(`rows.${index}.customArray`, [event.target.value])
    //                                                         },
    //                                                         size: 'small',
    //                                                         margin: 'dense',
    //                                                         value: itemValues.customArray.length ? itemValues.customArray[0] : ""
    //                                                     }
    //                                                 })
    //                                             }

    //                                             {
    //                                                 fieldType === inputTypesDef.multidropdown &&

    //                                                 RenderCustomFieldSelectionMultiDropdown({
    //                                                     index,
    //                                                     item,
    //                                                     itemValues,
    //                                                     selectProps: {
    //                                                         labelId: itemValues?.fieldLabel,
    //                                                         label: itemValues?.fieldLabel,
    //                                                         name: `rows.${index}.customArray`,
    //                                                         onChange: handleChange,
    //                                                         renderValue: (selected) => {

    //                                                             return (
    //                                                                 <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
    //                                                                     {
    //                                                                         getCustomFieldOptionNameByIds(selected, dataCustomFields, fieldKey).map((i, index) => (
    //                                                                             <Chip
    //                                                                                 key={index}
    //                                                                                 // color={'red'}
    //                                                                                 label={spliceString({ val: i, maxLength: 20 })}
    //                                                                             />
    //                                                                         ))
    //                                                                     }
    //                                                                 </Box>
    //                                                             )

    //                                                         },
    //                                                         size: 'small',
    //                                                         margin: 'dense',
    //                                                         multiple: true,
    //                                                         input: <OutlinedInput id="select-multiple-chip" label="Chip" />,
    //                                                         value: itemValues?.customArray ? itemValues.customArray : []
    //                                                     }
    //                                                 })
    //                                             }

    //                                         </Grid>
    //                                     </Grid>
    //                                 </ListItem>
    //                             )

    //                         })
    //                     }

    //                 </List>

    //             </Grid>
    //         </>
    //     )
    // }

    const RenderFormAuth = () => {

        return (
            <>
                <Grid item xs={12} sm={12} md={3} textAlign={"left"}>
                    <CommonSectionHeader
                        title={t('credential')}
                        subTitle={t('accessAuthentication')}
                    />
                </Grid>

                <Grid item xs={12} sm={12} md={9}>

                    <Grid container spacing={1}>
                        <Grid item xs={12} sm={12} md={6} textAlign={"left"}>
                            <TextField
                                disabled
                                margin="dense"
                                size="small"
                                fullWidth
                                name={"username"}
                                label={t('username')}
                                type="text"
                                variant="outlined"
                                value={values.username}
                                onChange={handleChange}
                            />
                        </Grid>

                        <Grid item xs={12} md={6} textAlign="left">
                            <FormControlLabel
                                control={
                                    <Switch
                                        sx={{
                                            ml: 2,
                                            my: 1
                                        }}
                                        name="status"
                                        checked={Boolean(values?.status)}
                                        onChange={(event, checked) => {
                                            setFieldValue("status", checked);
                                        }}
                                    />
                                }
                                label={
                                    Boolean(values?.status) ? t('enabled') : t('disabled')
                                }
                            />
                        </Grid>

                        <Grid item xs={12} sm={12} md={12} textAlign="left">

                            <Divider>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            size="small"
                                            onChange={handleAllowChangePassword}
                                        />
                                    }
                                    label={t('updatePassword')}
                                />
                            </Divider>

                        </Grid>

                        {
                            RenderChangePassword()
                        }

                    </Grid>
                </Grid>
            </>
        )
    }

    const RenderFormProfile = () => {

        return (
            <>
                <Grid item xs={12} sm={12} md={3} textAlign={"left"}>

                    <CommonSectionHeader
                        title={t('customerProfile')}
                        subTitle={t('fullDetailsOfCustomerInformation')}
                    />

                    <Divider sx={{ my: 1 }} />

                    <Typography
                        sx={{
                            color: grey[500],
                            fontSize: 11
                        }}
                    >
                        {`${customerInjectionProps.sourceProfileType.retrieveKey} : ${values?.injectionProps[customerInjectionProps.sourceProfileType.retrieveKey]}`}
                    </Typography>

                    <Typography
                        sx={{
                            color: grey[500],
                            fontSize: 11
                        }}
                    >
                        {`${customerInjectionProps.sourceClientRemId.retrieveKey} : ${values?.injectionProps[customerInjectionProps.sourceClientRemId.retrieveKey]}`}
                    </Typography>

                    <Typography
                        sx={{
                            color: grey[500],
                            fontSize: 11
                        }}
                    >
                        {`${customerInjectionProps.sourceAgentRemId.retrieveKey} : ${values?.injectionProps[customerInjectionProps.sourceAgentRemId.retrieveKey]}`}
                    </Typography>

                    {/* <Typography
                        sx={{
                            color: grey[500],
                            fontSize: 11
                        }}
                    >
                        {`${customerInjectionProps.marking.retrieveKey} : ${values?.injectionProps[customerInjectionProps.marking.retrieveKey]}`}
                    </Typography> */}

                </Grid>

                <Grid item xs={12} sm={12} md={9}>
                    <Grid container spacing={1}>

                        <Grid item xs={12} sm={12} md={6}>
                            <TextField
                                margin="dense"
                                size="small"
                                fullWidth
                                name={"firstname"}
                                label={t('firstName')}
                                type="text"
                                variant="outlined"
                                value={values.firstname}
                                onChange={handleChange}
                                error={touched.firstname && Boolean(errors.firstname)}
                                helperText={touched.firstname && errors.firstname}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6}>
                            <TextField
                                margin="dense"
                                size="small"
                                fullWidth
                                name={"lastname"}
                                label={t('lastName')}
                                type="text"
                                variant="outlined"
                                value={values.lastname}
                                onChange={handleChange}
                                error={touched.lastname && Boolean(errors.lastname)}
                                helperText={touched.lastname && errors.lastname}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6}>
                            <TextField
                                margin="dense"
                                size="small"
                                fullWidth
                                name={"companyname"}
                                label={t('companyName')}
                                type="text"
                                variant="outlined"
                                value={values.companyname}
                                onChange={handleChange}
                                error={touched.companyname && Boolean(errors.companyname)}
                                helperText={touched.companyname && errors.companyname}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6}>
                            <TextField
                                margin="dense"
                                size="small"
                                fullWidth
                                name={"regno"}
                                label={t('regNo')}
                                type="text"
                                variant="outlined"
                                value={values.regno}
                                onChange={handleChange}
                                error={touched.regno && Boolean(errors.regno)}
                                helperText={touched.regno && errors.regno}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6}>
                            <TextField
                                margin="dense"
                                size="small"
                                fullWidth
                                name={"code"}
                                label={t('customerCode')}
                                type="text"
                                variant="outlined"
                                value={values.code}
                                onChange={handleChange}
                                error={touched.code && Boolean(errors.code)}
                                helperText={touched.code && errors.code}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6}>
                            <TextField
                                margin="dense"
                                size="small"
                                fullWidth
                                name={"accountcode"}
                                label={t('accountCode')}
                                type="text"
                                variant="outlined"
                                value={values.accountcode}
                                onChange={handleChange}
                                error={touched.accountcode && Boolean(errors.accountcode)}
                                helperText={touched.accountcode && errors.accountcode}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6}>
                            <TextField
                                margin="dense"
                                size="small"
                                fullWidth
                                name={"email"}
                                label={t('email')}
                                type="email"
                                variant="outlined"
                                value={values.email}
                                onChange={handleChange}
                                error={touched.email && Boolean(errors.email)}
                                helperText={touched.email && errors.email}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6}>
                            <TextField
                                margin="dense"
                                size="small"
                                fullWidth
                                name={"contactno"}
                                label={t('contact')}
                                type="text"
                                variant="outlined"
                                value={values.contactno}
                                onChange={handleChange}
                                error={touched.contactno && Boolean(errors.contactno)}
                                helperText={touched.contactno && errors.contactno}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6}>
                            <TextField
                                margin="dense"
                                size="small"
                                fullWidth
                                name={"salesperson"}
                                label={t('salesperson')}
                                type="text"
                                variant="outlined"
                                value={values.salesperson}
                                onChange={handleChange}
                                error={touched.salesperson && Boolean(errors.salesperson)}
                                helperText={touched.salesperson && errors.salesperson}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6}>
                            <TextField
                                margin="dense"
                                size="small"
                                fullWidth
                                name={"remark"}
                                label={t('remark')}
                                type="text"
                                multiline
                                rows={3}
                                variant="outlined"
                                value={values.remark}
                                onChange={handleChange}
                                error={touched.remark && Boolean(errors.remark)}
                                helperText={touched.remark && errors.remark}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </>
        )
    }

    const RenderBranchList = () => {

        if (!values) return <></>

        return (
            <StyledCard>
                <Grid container spacing={0.5}>
                    <Grid item xs={12} sm={12} md={3} textAlign={"left"}>
                        <CommonSectionHeader
                            title={t('branches')}
                            subTitle={t('branchDetailsInformation')}
                        />
                    </Grid>

                    <Grid item xs={12} sm={12} md={9}>
                        {
                            RenderBranch()
                        }
                    </Grid>
                </Grid>
            </StyledCard>
        )
    }

    // const RenderBranchUserList = () => {

    //     if (!values) return <></>

    //     return (
    //         <StyledCard
    //             sx={{
    //                 mt: 2
    //             }}
    //         >
    //             <Grid container spacing={0.5}>
    //                 <Grid item xs={12} sm={12} md={3} textAlign={"left"}>
    //                     <CommonSectionHeader
    //                         title={t('branchUsers')}
    //                         subTitle={t('branchUserDetailsInformation')}
    //                     />
    //                 </Grid>

    //                 <Grid item xs={12} sm={12} md={9}>

    //                     {
    //                         RenderBranchUser()
    //                     }

    //                 </Grid>
    //             </Grid>
    //         </StyledCard>
    //     )
    // }

    const RenderBranch = () => {

        if (!dataBranches.length) return <RenderEmpty branchType={branchTypes.customer} parentId={id} />

        return (
            <StyledCard2>
                <List
                    sx={{
                        width: '100%',
                        position: 'relative',
                        overflow: 'auto',
                        minHeight: 300,
                        '& ul': { padding: 0 },
                    }}
                    disablePadding
                >
                    <StyledListHeader>{t('branches')}</StyledListHeader>
                    {
                        dataBranches.map((i, index) => (
                            <ListItem
                                key={`${index}`}
                                disablePadding
                                divider
                            >
                                <ListItemButton
                                    disableGutters
                                    sx={{
                                        px: 2
                                    }}
                                >
                                    <Grid container spacing={1}>
                                        <Grid item md={11} sm={11} xs={11} display={"flex"} justifyContent={"flex-start"} alignItems={"center"}
                                            sx={{
                                                fontSize: 15
                                            }}
                                        >
                                            {
                                                `${i?.branch_name} (${i?.branch_code})`
                                            }

                                            {
                                                i?.status === "0" &&
                                                <Tooltip
                                                    title="Disabled"
                                                >
                                                    <Box sx={{ ml: 1 }}>
                                                        <CommonIcons name={icons.disabled} sx={{ color: red[500] }} />
                                                    </Box>
                                                </Tooltip>
                                            }

                                            {
                                                i?.is_hq === "1" &&
                                                <Tooltip
                                                    title="Main Branch"
                                                >
                                                    <Box sx={{ ml: 1 }}>
                                                        <CommonIcons name={icons.default} sx={{ color: "primary" }} />
                                                    </Box>
                                                </Tooltip>
                                            }

                                            {
                                                (i?.type === "branch" || i?.type === "branch_shipping") &&
                                                <Tooltip
                                                    title="Branch"
                                                >
                                                    <Box sx={{ ml: 1 }}>
                                                        <CommonIcons name={icons.warehouse} sx={{ color: "primary" }} />
                                                    </Box>
                                                </Tooltip>
                                            }

                                            {
                                                (i?.type === "branch_shipping" || i?.type === "shipping_address") &&
                                                <Tooltip
                                                    title="Shipping Address"
                                                >
                                                    <Box sx={{ ml: 1 }}>
                                                        <CommonIcons name={icons.logistic} sx={{ color: "primary" }} />
                                                    </Box>
                                                </Tooltip>
                                            }

                                        </Grid>
                                        <Grid item md={1} sm={1} xs={1} display={"flex"} justifyContent={"center"} alignItems={"center"}>
                                            {
                                                isPermissionAllow({ scopeType: scopeTypes[scopeIds.userBranches.id].customer.id, functionType: functionTypes.pageUpdate.id }) &&

                                                <IconButton
                                                    color={"primary"}
                                                    size="small"
                                                    onClick={() => handleItemEdit({ branchType: branchTypes.customer, itemId: i.id })}
                                                >
                                                    <CommonIcons name={icons.edit} />
                                                </IconButton>
                                            }

                                            {/* {
                                                isPermissionAllow({ scopeType: scopeTypes[scopeIds.userBranches.id].customer.id, functionType: functionTypes.remove.id }) &&

                                                <IconButton
                                                    color={"error"}
                                                    size="small"
                                                    onClick={() => handleItemDelete({ itemId: i.id, branchType: branchTypes.customer })}
                                                    sx={{
                                                        mr: 2
                                                    }}
                                                >
                                                    <CommonIcons name={icons.remove} />
                                                </IconButton>
                                            } */}
                                        </Grid>
                                    </Grid>
                                </ListItemButton>
                            </ListItem>
                        ))
                    }
                </List>

                {/* {
                    isPermissionAllow({ scopeType: scopeTypes[scopeIds.userBranches.id].customer.id, functionType: functionTypes.pageNew.id }) &&

                    <Box
                        sx={{ m: 1 }}
                    >
                        <Button
                            variant={"outlined"}
                            size="medium"
                            fullWidth
                            onClick={() => handleItemNew({ branchType: branchTypes.customer })}
                        >
                            <CommonIcons name={icons.add} />
                            <Box sx={{ ml: 1 }}>
                                {t('new')}
                            </Box>
                        </Button>
                    </Box>
                } */}
            </StyledCard2>
        )
    }

    // const RenderBranchUser = () => {

    //     // console.log('dataBranchUsers', dataBranchUsers)

    //     if (!dataBranchUsers.length) return <RenderBranchUserEmpty branchUserType={branchUserTypes.customer} parentId={id} />

    //     return (
    //         <StyledCard2>
    //             <List
    //                 sx={{
    //                     width: '100%',
    //                     position: 'relative',
    //                     overflow: 'auto',
    //                     minHeight: 300,
    //                     '& ul': { padding: 0 },
    //                 }}
    //                 disablePadding
    //             >
    //                 <StyledListHeader>Users</StyledListHeader>
    //                 {
    //                     dataBranchUsers.map((i, index) => (
    //                         <ListItem
    //                             key={`${index}`}
    //                             disablePadding
    //                             divider
    //                         >
    //                             <ListItemButton
    //                                 disableGutters
    //                                 sx={{
    //                                     px: 2
    //                                 }}
    //                             >
    //                                 <Grid container spacing={1}>
    //                                     <Grid item md={11} sm={11} xs={11} display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
    //                                         {
    //                                             `${i?.firstname} ${i?.lastname} (${i.username})`
    //                                         }

    //                                         {
    //                                             i?.status !== "1" &&
    //                                             <Box sx={{ ml: 1 }}>
    //                                                 <CommonIcons name={icons.disabled} sx={{ color: red[600] }} />
    //                                             </Box>
    //                                         }

    //                                     </Grid>
    //                                     <Grid item md={1} sm={1} xs={1} display={"flex"} justifyContent={"center"} alignItems={"center"}>
    //                                         {
    //                                             isPermissionAllow({ scopeType: scopeTypes[scopeIds.branchUsers.id].customer.id, functionType: functionTypes.pageUpdate.id }) &&

    //                                             <IconButton
    //                                                 color={"primary"}
    //                                                 size="small"
    //                                                 onClick={() => handleItemEdit({ branchUserType: branchUserTypes.customer, itemId: i.user_id })}
    //                                             >
    //                                                 <CommonIcons name={icons.edit} />
    //                                             </IconButton>
    //                                         }

    //                                         {
    //                                             isPermissionAllow({ scopeType: scopeTypes[scopeIds.branchUsers.id].customer.id, functionType: functionTypes.remove.id }) &&

    //                                             <IconButton
    //                                                 color={"error"}
    //                                                 size="small"
    //                                                 onClick={() => handleItemDelete({ itemId: i.user_id, branchUserType: branchUserTypes.customer })}
    //                                                 sx={{
    //                                                     mr: 2
    //                                                 }}
    //                                             >
    //                                                 <CommonIcons name={icons.remove} />
    //                                             </IconButton>
    //                                         }
    //                                     </Grid>
    //                                 </Grid>
    //                             </ListItemButton>
    //                         </ListItem>
    //                     ))
    //                 }
    //             </List>

    //             {
    //                 isPermissionAllow({ scopeType: scopeTypes[scopeIds.branchUsers.id].customer.id, functionType: functionTypes.pageNew.id }) &&

    //                 <Box
    //                     sx={{ m: 1 }}
    //                 >
    //                     <Button
    //                         variant={"outlined"}
    //                         size="medium"
    //                         fullWidth
    //                         onClick={() => handleItemNew({ branchUserType: branchUserTypes.customer })}
    //                     >
    //                         <CommonIcons name={icons.add} />
    //                         <Box sx={{ ml: 1 }}>
    //                             New
    //                         </Box>
    //                     </Button>
    //                 </Box>
    //             }
    //         </StyledCard2>
    //     )
    // }

    const RenderForm = () => {

        if (!values) return <></>

        return (

            <form onSubmit={formik.handleSubmit}>
                <StyledCard>
                    <Grid container spacing={0.5}>
                        {
                            RenderFormAuth()
                        }

                        <Grid item xs={12}>
                            <Divider sx={{ my: 2 }} />
                        </Grid>

                        {
                            RenderFormProfile()
                        }

                        <Grid item xs={12}>
                            <Divider sx={{ my: 2 }} />
                        </Grid>

                        {
                            RenderMarkingItemInfo()
                        }

                    </Grid>
                </StyledCard>

                <Grid container spacing={1} sx={{ pl: 2, pr: 2 }}>
                    <Grid item md={12} textAlign={"right"}>
                        <Button
                            type="submit"
                            // fullWidth
                            variant="contained"
                            sx={{
                                mt: 3,
                                mb: 2
                            }}
                            disabled
                        >
                            {t('saveChanges')}
                        </Button>
                    </Grid>

                </Grid>
            </form>

        )
    }

    return (
        <Box>
            {
                getHtmlHead({ routeType, title: t('updateCustomer') })
            }

            <CommonBreadcumbs
                routeType={routeType}
                pageTitle={t('updateCustomer')}
                breadcrumbs={[
                    {
                        displayText: t('customers'),
                        props: {
                            href: getRoute(`users/customers`)
                        }
                    },
                    {
                        displayText: `${t('updateCustomer')} (*)`,
                        props: {
                            color: 'secondary.main'
                        }
                    },
                ]}
            />

            {

                // isPermissionAllow({ scopeType: scopeTypes[scopeIds.user.id].customer.id, functionType: functionTypes.pageUpdate.id }) ?
                isPermissionAllow({ functionType: functionTypes.pageUpdate.id }) ?
                    RenderForm()
                    :
                    <></>
            }

            {
                RenderBranchList()
            }

            {/* {
                RenderBranchUserList()
            } */}


            {/* <Divider sx={{ my: 1 }} />

            <Typography
                sx={{
                    fontSize: 13
                }}
            >
                {JSON.stringify(values?.injectionProps)}
            </Typography> */}

        </Box>
    )
}